import { React, ts } from '_core';

import Chart from './chart';
import Form from './form';
import { DraftParams, Params } from './types';

type UniversePreviewAssetPertinenceProps = {
  id: string;
  mode: ts.enums.CHART_MODE_ENUM;
  params: Params | DraftParams;
  setParams: (_p: DraftParams) => void;

  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  widgetPaths?: Record<'universe_asset_pertinence', string>;
  goFullScreen?: (_b: string) => void;
  fullScreen?: boolean;
  context?: ts.types.universe.UniversePreviewContext;
  queryParams?: { initial?: string };
};

const UniversePreviewAssetPertinence = ({
  id,
  loadWidgetData,
  widgetPaths,
  mode,
  context,
  params,
  setParams,
  fullScreen,
  goFullScreen,
  queryParams,
}: UniversePreviewAssetPertinenceProps) => {
  const renderJobComponent = () => (
    <>
      <Chart
        id={id}
        loadWidgetData={loadWidgetData}
        assetPertinence={widgetPaths['universe_asset_pertinence']}
        fullScreen={fullScreen}
        context={context}
        queryParams={queryParams}
        goFullScreen={goFullScreen}
        params={params as Params}
        setParams={setParams}
      />
    </>
  );

  return (
    <>
      {mode == ts.enums.CHART_MODE_ENUM.EDIT ? (
        <Form
          params={params}
          setParams={setParams}
          universeStartDate={context?.start_date}
          universeEndDate={context?.end_date}
        />
      ) : (
        renderJobComponent()
      )}
    </>
  );
};

export default UniversePreviewAssetPertinence;
